module.exports = __webpack_public_path__ + "img/picture_1.8115353b.png";